<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>打标日志列表</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.supply_name"
                      placeholder="商家"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.goods_no"
                      placeholder="商品货号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.goods_kh"
                      placeholder="款号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-if="searchOptions"
                      v-model="form.pgid"
                      multiple
                      filterable
                      placeholder="请选择代采组"
                    >
                      <el-option
                        v-for="item in searchOptions.optionPg"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-if="searchOptions"
                      v-model="form.type"
                      multiple
                      placeholder="选择类型"
                    >
                      <el-option
                        v-for="item in searchOptions.optionsType"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-if="searchOptions"
                      v-model="form.status"
                      multiple
                      placeholder="选择状态"
                    >
                      <el-option
                        v-for="item in searchOptions.optionsStatus"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_supply_dbid"
                      placeholder="是否爆版打标"
                    >
                      <el-option
                        v-for="item in is_supply_dbid_option"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.operator_name"
                      placeholder="操作人"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.package_no"
                      placeholder="包裹号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.pici_no"
                      placeholder="批次单号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-if="searchOptions"
                      v-model="form.origin"
                      placeholder="选择地区"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in searchOptions.origin"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.dbid"
                      placeholder="打标ID"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.sku"
                      placeholder="sku"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-if="searchOptions"
                      v-model="form.pg_id"
                      placeholder="请选择买手组"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in searchOptions.optionPicker"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.referer_type"
                      placeholder="欠货类型"
                    >
                      <el-option
                        v-for="item in referer_type"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                      <el-option label="售后欠货" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.da_biao_value_added"
                      placeholder="计件增值"
                    >
                      <el-option
                        v-for="item in da_biao_value_added"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-if="searchOptions"
                      v-model="form.separate_type"
                      placeholder="分离类型"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="(item, index) in searchOptions.separate_type"
                        :key="index"
                        :label="item"
                        :value="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-if="searchOptions"
                      v-model="form.storehouse_id"
                      placeholder="所属仓库"
                    >
                      <el-option
                        v-for="item in searchOptions.optionStoreHouse"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="创建时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="更新时间：">
                  <el-date-picker
                    v-model="form.update_time"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="dbid"
              label="打标id"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <div type="text" @click="openQrCode('dbid=' + scope.row.dbid)">
                  {{ scope.row.dbid }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="pici_no" label="批次号" align="center">
            </el-table-column>
            <el-table-column
              prop="package_record_no"
              label="包裹号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="package_record_time"
              label="包裹生成时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="渠道商"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="desk_no" label="工作台" align="center">
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_name"
              label="买手组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="blp_img"
              label="商品色卡图"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <img
                  v-viewer
                  :src="scope.row.thumb"
                  alt=""
                  style="max-width: 50px; max-height: 50px"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_kh"
              label="款号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="sku"
              label="sku"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="r_referer_type_text"
              label="欠货类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="blp_type_text"
              label="不良品类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cp_cat_name"
              label="质检次品二级分类"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="blp_note"
              label="备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="blp_img"
              label="次品图片"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <img
                  v-viewer
                  :src="scope.row.blp_img"
                  alt=""
                  style="max-width: 50px; max-height: 50px"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="sdbr_text"
              label="是否爆版打标"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="origin_text"
              label="地区"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="type_text"
              label="类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dbid_bd_type"
              label="补打类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status_text"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="da_biao_value_added_text"
              label="计件增值"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="work_id"
              label="工单id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="fenli_type"
              label="分离类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cross_remark"
              label="分离失败原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="store_house"
              label="所属仓库"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="safe_lock"
              label="安全扣ID"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="操作人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="update_time"
              label="更新时间"
              width="100"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Global_ from "../components/Global";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        origin: 1,
        create_time: this.$excalibur.getDateTimeOnHours(-1, 6),
        get_search_options: 0,
      },
      loading: false,
      url: "/erp/daBiaoRecord/lists",
      origin: 1,
      where: -1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      referer_type: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "代采欠货",
        },
        {
          value: 2,
          label: "退换货欠货",
        },
      ],
      da_biao_value_added: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "需换包装",
        },
        {
          value: 2,
          label: "需放配件",
        },
      ],
      is_supply_dbid_option: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      searchOptions: null,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    openQrCode(text) {
      if (Global_.environment === 0) {
        this.$alert(
          `<img src="https://tool.oschina.net/action/qrcode/generate?data=${text}" />`,
          text,
          {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false,
            closeOnClickModal: true,
            center: true,
          }
        );
      }
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row, index) {
      const curRow = this.resData.list[index];
      this.$router.push(
        `/home/stockdetail/${row.goods_no}?co_id=${curRow.co_id}&where=${curRow.where}&si_id=${curRow.si_id}`
      );
    },
    search() {
      this.form.page = 1;
      this.form.get_search_options = 0;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = this.filteredForm.origin;
          this.where = this.filteredForm.where;
          this.curPage = 1;
        }
      });
    },
    selectOrigin(key) {
      this.form.origin = this.origin = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    selectWhere(key) {
      this.form.where = this.where = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.form.get_search_options = 1;
      this.$http
        .post(this.url, this.form)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.searchOptions = res.data.data;
          }
        })
        .finally(() => {
          this.loading = false;
          this.form.get_search_options = 0;
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/MarkingLogList.vue